<template>
  <div>
    <p>Choose sample quest</p>
    <div class="list-game-choices">
      <button v-for="quest in $store.state.quests"
              :key="quest.name"
              :disabled="quest.disabled"
              @click="$store.commit('setCurrentQuest', quest)">{{quest.name}}</button>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$store.commit('setShowLogo', true);
  },
};
</script>

<style lang="scss" scoped>


</style>
